import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PackageUtilizationExpectation, PackageUtilizationExpectationBulkCreate } from 'types';
import { client } from 'utils/api-client';

import { PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY } from './useAutoCompletePackage';
import { PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY } from './useExpectations';

export default function useBulkCreateExpectations(): UseMutationResult<
  AxiosResponse<PackageUtilizationExpectation[]>,
  AxiosError<ErrorMessage>,
  PackageUtilizationExpectationBulkCreate
> {
  const queryClient = useQueryClient();

  const createExpectations = (
    expectations: PackageUtilizationExpectationBulkCreate,
  ): Promise<AxiosResponse<PackageUtilizationExpectation[]>> => {
    return client.post('/package-utilization-expectations/bulk-create/', expectations);
  };

  return useMutation(createExpectations, {
    onSuccess: () => {
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY]);
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY]);
    },
  });
}
